<script>
import TwTransitionContainer from '@/components/generic/tw-transition-container.vue'
import FundraiserSupporters from '@/components/fundraisers/fundraiser-supporters.vue'
import FundraiserUpdatesViewPublic from '@/components/fundraisers/fundraiser-updates-view-public.vue'
import FundraiserTeams from '@/components/fundraisers/fundraiser-tabs/fundraiser-teams.vue'
import FundraiserPagesList from '@/components/fundraisers/fundraiser-pages-frontend-list.vue'
import TwTabsNavigation from '@/components/generic/tabs/tw-tabs-navigation.vue'

export default {
  name: 'FundraiserTabs',
  components: { TwTabsNavigation, FundraiserPagesList, FundraiserTeams, FundraiserUpdatesViewPublic, FundraiserSupporters, TwTransitionContainer },
  props: {
    fundraiser: {
      type: Object,
      required: true
    },
    team: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ActiveTab: 'people'
    }
  },
  computed: {
    tabs() {
      const tabs = []
      if(this.fundraiser && this.fundraiser.cached && this.fundraiser.cached.fundraiser_pages_count && this.fundraiser.cached.fundraiser_pages_count > 0) {
        tabs.push({ name: 'People', slug: 'people', current: this.ActiveTab === 'people',  badge: this.fundraiser.cached.fundraiser_pages_count ?? null})
      }
      if(this.fundraiser.settings && this.fundraiser.settings.enable_teams && !this.team) {
        tabs.push({ name: 'Teams', slug: 'teams', current: this.ActiveTab === 'teams', badge: this.fundraiser.cached.fundraiser_teams_count ?? null })
      }
      return tabs
    }
  }
}
</script>

<template>
  <div>
    <tw-tabs-navigation v-model="ActiveTab" :tabs="tabs" id-field="slug" />
    <tw-transition-container class="mt-4 pt-2">
      <div v-if="ActiveTab === 'people'">
        <fundraiser-pages-list :team="team" :fundraiser="fundraiser" />
      </div>
      <div v-else-if="ActiveTab === 'donations'">
        <fundraiser-supporters :fundraiser="fundraiser" />
      </div>
      <div v-else-if="ActiveTab === 'top-fundraisers'">
        <fundraiser-pages-list :fundraiser="fundraiser" />
      </div>
      <div v-else-if="ActiveTab === 'updates'">
        <fundraiser-updates-view-public :updatable-type="fundraiser.object_type" :updatable-id="fundraiser.id" />
      </div>
      <div v-else-if="ActiveTab === 'teams'">
        <fundraiser-teams :fundraiser="fundraiser" />
      </div>
      <div v-else-if="ActiveTab === 'team'">
        <fundraiser-teams :fundraiser="fundraiser" :teams="[fundraiser.team]" always-expanded />
      </div>
    </tw-transition-container>
  </div>
</template>

<style scoped>

</style>
